export default class Profissional {
  constructor() {
    this.id = 0;
    this.descricao = "";
    this.nome = "";
  }
}
